import React from 'react';

import { ButtonDropdown, Icon } from '@amzn/awsui-components-react';

import { useIntl } from 'react-intl';

import globeIcon from '../assets/globe.svg';
import globalMessages from '../i18n/global.messages';
import { useLocaleContext } from '../contexts/LocaleContextProvider';
import ScreenReaderHidden from './ScreenReaderHidden';
import { Locale, LOCALES, TextDirection } from '../constants/locales';
import metricsService from '../services/metrics';

import './LocaleMenu.css';

/**
 * Filter to only include LTR locales.
 * RTL locales are not yet supported. https://sim.amazon.com/issues/Vibe-485
 */
const isLtrLocale = (locale: Locale) => locale.dir === TextDirection.LTR;

const idSeparator = ':';

const LocaleMenu = () => {
  const { formatMessage } = useIntl();
  const { locale, setLocale } = useLocaleContext();

  return (
    <ButtonDropdown
      items={[
        ...Object.keys(LOCALES)
          .map((key) => LOCALES[key])
          .filter(isLtrLocale)
          .map((l) => ({
            text: l.label,
            id: `header-localeItem${idSeparator}${l.id}`,
            disabled: locale === l.id,
          })),
      ]}
      onItemClick={(event) => {
        const selectedLocale = event.detail.id.split(idSeparator)[1];
        setLocale(selectedLocale);
        const publisher = metricsService.getPublisher('LocaleMenu');
        publisher.publishCounterMonitor('ClickLocale', 1);
        publisher.publishStringTruncate('SelectedLocale', selectedLocale);
      }}
      data-testid="header-localeMenu"
    >
      <span className="LocaleMenu__icon">
        <Icon url={globeIcon} alt="" />
      </span>
      <ScreenReaderHidden>
        {formatMessage(globalMessages.selectPreferredLocale)}
      </ScreenReaderHidden>
      <ScreenReaderHidden>
        {formatMessage(globalMessages.currentLocaleSelection)}
      </ScreenReaderHidden>
      {LOCALES[locale].label}
    </ButtonDropdown>
  );
};

export default LocaleMenu;
